import { createFileRoute, redirect } from '@tanstack/react-router';

import { profilesSearchSchema } from '@/features/llm-profiles';

// The page this address used to serve is `/admin/harnesses` now (spec 240
// FR-011). Kept so a bookmark or an old link still lands somewhere: one hop,
// before anything renders, carrying the profiles grid's order and filter along.
export const Route = createFileRoute('/admin/ai-providers')({
  validateSearch: profilesSearchSchema,
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's redirect is thrown by design
    throw redirect({ to: '/admin/harnesses', search, replace: true });
  },
});
